import { END_POINTS } from "../constants/url";
import { CommonBody, FaqRes, CMS, GetFaqResponse } from "../types/General";
import { User } from "../types/User";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  data?: User;
  message: string;
}

interface CommonResponse {
  statusCode: number;
  message?: string;
  data?: any;
}

interface GetCmsResponse {
  _id: string;
  email: string;
  phone: string;
  terms: string;
  privacyPolicy: string;
  aboutUs: string;
  dialCode: string;
}

export interface GetSettingResponse {
  inspectionFee: number;
  postingFee: number;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  id: string;
}
export interface CountryTaxEntry {
  country: string;
  gst: number;
  _id?: string;
}
export interface GetTex {
  _id: string;
  tax: CountryTaxEntry[];
  globalTax?: number;
  createdAt: string;
  updatedAt: string;
  __v: number;
}
export interface UpdateTexBody {
  globalTax?: number;
  tax: CountryTaxEntry[];
}
export const faqApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCms: builder.query<CommonResponse & { data: GetCmsResponse }, {}>({
      query: () => ({
        url: END_POINTS.cms,
        method: "GET",
      }),
    }),
    getTax: builder.query<CommonResponse & { data: GetTex }, {}>({
      query: () => ({
        url: END_POINTS.tax,
        method: "GET",
      }),
    }),
    updateCms: builder.mutation<CommonResponseType & { data: CMS }, any>({
      query: (body) => ({
        url: `${END_POINTS.cms}`,
        method: "PUT",
        body,
      }),
    }),
    updateTex: builder.mutation<CommonResponseType & { data: any }, UpdateTexBody>({
      query: (body) => ({
        url: `${END_POINTS.tax}`,
        method: "PUT",
        body,
      }),
    }),
    getFAQ: builder.query<
      CommonResponseType & { data: GetFaqResponse },
      {
        search: string;
        page: number;
      }
    >({
      query: ({ search, page }) => ({
        url: `${END_POINTS.faq}?page=${page}&search=${search}`,
        method: "GET",
      }),
    }),
    addFAQ: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.faq,
        method: "POST",
        body,
      }),
    }),
    updateFaq: builder.mutation<
      CommonResponseType & { data: FaqRes },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.faq}/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetCmsQuery,
  useUpdateCmsMutation,
  useLazyGetFAQQuery,
  useAddFAQMutation,
  useUpdateFaqMutation,
  useLazyGetTaxQuery,
  useUpdateTexMutation
  // useLazyDeleteFaqQuery,
} = faqApi;
